import React from 'react';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';
import PropTypes from 'prop-types';

export const DrawerFooter = ({ children }) => {
  return (
    <Box m={2} display="flex" flexGrow={1} flexDirection="column-reverse">
      {children}
    </Box>
  );
};

DrawerFooter.propTypes = {
  children: PropTypes.element,
};

export default DrawerFooter;
